import { cn } from '@/utils'

// Resting and open share one box, margin pulled back by its own padding, so a click changes the
// surface under the words and never moves them.
const FIELD_BOX = '-mx-1 rounded px-1 py-0.5'

// Only the field under the pointer answers it, so the column never turns into a form.
export const FIELD_AT_REST = cn(
  FIELD_BOX,
  'group/field inline-flex max-w-full cursor-pointer items-start gap-1.5 break-words text-left transition-colors hover:bg-neutral-100',
)

export const FIELD_OPEN = cn(
  FIELD_BOX,
  'min-h-0 border-0 bg-white shadow-none outline-none ring-1 ring-neutral-300 placeholder:text-ink-subtle focus-visible:ring-neutral-900',
)

export const FIELD_EMPTY = 'font-normal text-ink-subtle'
